var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"logo-avatar",attrs:{"color":"secondary","size":"50"}},[(_vm.type === 'mdi')?[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.icon))])]:(_vm.type === 'svg')?[_c('img',{staticClass:"logo-svg",attrs:{"src":_vm.icon,"alt":"Logo"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }